import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';

import { AppListenerService, currentLang } from '@hiptraveler/common';
import * as Feature from '@hiptraveler/features/meta-tag';

@Injectable()
export class SearchAndDefaultPageService {

  constructor(
    private router: Router,
    private appListener: AppListenerService,
    private metaTagService: Feature.MetaTagService,
    private service: Feature.SearchAndDefaultPageObserverService
  ) { }

  observe(): void {

    if (this.appListener.invalidRequest) return;

    if (Feature.validateRootPath(this.service.originalUrl)) {
      console.log('@@@ ', 'ROOT PAGE');
      setTimeout(() => this.setHomepageMetaTags());
      return;
    }

    if (!Feature.validateAppPath(this.service.originalUrl)) return;

    if (!this.service.originalUrl || !Feature.validateUrl(this.service.originalUrl)) return;
    console.log('@@@ ', 'NON-ROOT PAGE');

    this.metaTagService.navigationEnd$.subscribe((config: Feature.ObserverConfig) => {
      this.updateRootMetaTags(config);
    });

    this.service.locationChanges$.subscribe((metadata: Feature.Metadata | null) => {

      console.log('@@@ locationChanges$', !!metadata ? 'WITH-LOCATION' : 'WITHOUT-LOCATION');

      metadata
        ? this.updateRootMetaTags({ metadata, url: this.router.url, lang: currentLang() })
        : this.service.config$.subscribe(this.updateRootMetaTags.bind(this))
    });
  }

  private setHomepageMetaTags(): void {
    this.service.rootConfig$.pipe( take(1) ).subscribe((config: Feature.ObserverConfig) => {
      if (config?.metadata) {
        config.metadata['url'] = config.url
      }
      this.metaTagService.updateMetaData({ ...Feature.defaultMetaTagData, ...(config?.metadata || {}) });
    });
  }
    
  private updateRootMetaTags(config: Feature.ObserverConfig): void {
    Feature.observeDefaultAndSearchPage(config, e => this.metaTagService.updateMetaData(e));
  }

}
